import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import styles from "./index.module.css";
import { profileSchema } from "../../yup";
import { Button } from "react-bootstrap";
import { ButtonLoader } from "../ButtonLoader";

const ProfileForm = ({ user, onSubmit }) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(profileSchema),
    defaultValues: {
      name: user.name,
    },
  });

  return (
    <>
      <form className={styles.profileForm}>
        <div className={styles.field}>
          <label>Name</label>
          <input {...register("name")} />
          {errors.name && <p className={styles.error}>{errors.name.message}</p>}
        </div>

        <div className={styles.field}>
          <label>Email</label>
          <input value={user.email} disabled className={styles.disabled} />
        </div>
      </form>
      <div className={styles.formActions}>
        <Button
          type="submit"
          className={styles.profileSaveBtn}
          disabled={isSubmitting}
          onClick={handleSubmit(onSubmit)}
        >
          {isSubmitting ? <ButtonLoader show={isSubmitting} /> : "Submit"}
        </Button>
        {/* <Button
          variant="outline-primary"
          type="button"
          className={styles.cancelBtn}
          onClick={onCancel}
        >
          Cancel
        </Button> */}
      </div>
    </>
  );
};

export default ProfileForm;
